// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ----------------------------- nav bar style start -------------------------------------- */
.custom-navbar-header {
  
  background-color: #4733C9;
  padding-bottom: 0px;
  border-bottom: 0.5px solid #eeeeee !important;
}
.navbar-brand-custom {
  padding: 0;
  margin: 0;
}
.logo-main-radiant{
  width: 50px;
}
.custom-navbar-header .navbar-brand {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
}
.custom-navbar-header .navbar-brand > span {
  opacity: 0.4;
}
.custom-navbar-header .navbar-toggler {
  border-color: #4733C9;
  background-color: #ffffff;
}
.custom-navbar-header .navbar-toggler:active,
.custom-navbar-header .navbar-toggler:focus {
  box-shadow: none;
  outline: none;
}
@media (min-width: 992px) {
  .custom-navbar-header .custom-navbar-header-nav li {
    margin-left: 15px;
    margin-right: 15px;
  }
}
.custom-navbar-header .custom-navbar-header-nav li a {
  font-weight: 300;
  color: #ffffff;
  opacity: 1;
  transition: 0.3s all ease;
  position: relative;
  padding-bottom: 15px;
}
@media (max-width: 768px) {
  .custom-navbar-header{
    background-color: #4733C9 !important;
    border-bottom: none !important;
  }}
@media (min-width: 768px) {
 
  .custom-navbar-header .custom-navbar-header-nav li a:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 8px;
    right: 8px;
    background: #4733C9;
    height: 5px;
    opacity: 1;
    visibility: visible;
    width: 0;
    transition: 0.15s all ease-out;
  }
}
.custom-navbar-header .custom-navbar-header-nav li a:hover {
  opacity: 1;
  color: #ffffff;
  font-weight: 500;
}
.custom-navbar-header .custom-navbar-header-nav li a:hover:before {
  width: calc(100% - 16px);
}
.custom-navbar-header .custom-navbar-header-nav li.active a {
  opacity: 1;
  color: #ffffff;
  font-weight: 500;
}
.custom-navbar-header .custom-navbar-header-nav li.active a:before {
  width: calc(100% - 16px);
  color: #ffffff;
  font-weight: 500;
}
.custom-navbar-header .custom-navbar-header-cta {
  margin-left: 0 !important;
  flex-direction: row;
}
@media (min-width: 768px) {
  .custom-navbar-header .custom-navbar-header-cta {
    margin-left: 40px !important;
  }
}
.custom-navbar-header .custom-navbar-header-cta li {
  margin-left: 0px;
  margin-right: 0px;
}
.custom-navbar-header .custom-navbar-header-cta li:first-child {
  margin-right: 20px;
}

.button-navbar {
  background-color: #4733C9;
  color: white;
  font-family: "Manrope", sans-serif;
  border-radius: 5px;
}

/* ----------------------------- nav bar style start -------------------------------------- */

.navlink-btn .active {
  background-color: transparent;
  border: 1px solid #4733C9;
  color: #4733C9;
  box-shadow: 0 1px 2px 0 #28af4c3b, 0 1.5px 5px 0 #28af4c3f;
}
`, "",{"version":3,"sources":["webpack://./src/components/HeaderComponent/headerComponent.css"],"names":[],"mappings":"AAAA,6FAA6F;AAC7F;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;;EAGE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EAGV,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE;IACE,oCAAoC;IACpC,8BAA8B;EAChC,CAAC;AACH;;EAEE;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,QAAQ;IAGR,8BAA8B;EAChC;AACF;AACA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EAIzB,mBAAmB;AACrB;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,6FAA6F;;AAE7F;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,0DAA0D;AAC5D","sourcesContent":["/* ----------------------------- nav bar style start -------------------------------------- */\n.custom-navbar-header {\n  \n  background-color: #4733C9;\n  padding-bottom: 0px;\n  border-bottom: 0.5px solid #eeeeee !important;\n}\n.navbar-brand-custom {\n  padding: 0;\n  margin: 0;\n}\n.logo-main-radiant{\n  width: 50px;\n}\n.custom-navbar-header .navbar-brand {\n  font-size: 20px;\n  font-weight: 600;\n  color: #ffffff;\n}\n.custom-navbar-header .navbar-brand > span {\n  opacity: 0.4;\n}\n.custom-navbar-header .navbar-toggler {\n  border-color: #4733C9;\n  background-color: #ffffff;\n}\n.custom-navbar-header .navbar-toggler:active,\n.custom-navbar-header .navbar-toggler:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n}\n@media (min-width: 992px) {\n  .custom-navbar-header .custom-navbar-header-nav li {\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n}\n.custom-navbar-header .custom-navbar-header-nav li a {\n  font-weight: 300;\n  color: #ffffff;\n  opacity: 1;\n  -webkit-transition: 0.3s all ease;\n  -o-transition: 0.3s all ease;\n  transition: 0.3s all ease;\n  position: relative;\n  padding-bottom: 15px;\n}\n@media (max-width: 768px) {\n  .custom-navbar-header{\n    background-color: #4733C9 !important;\n    border-bottom: none !important;\n  }}\n@media (min-width: 768px) {\n \n  .custom-navbar-header .custom-navbar-header-nav li a:before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 8px;\n    right: 8px;\n    background: #4733C9;\n    height: 5px;\n    opacity: 1;\n    visibility: visible;\n    width: 0;\n    -webkit-transition: 0.15s all ease-out;\n    -o-transition: 0.15s all ease-out;\n    transition: 0.15s all ease-out;\n  }\n}\n.custom-navbar-header .custom-navbar-header-nav li a:hover {\n  opacity: 1;\n  color: #ffffff;\n  font-weight: 500;\n}\n.custom-navbar-header .custom-navbar-header-nav li a:hover:before {\n  width: calc(100% - 16px);\n}\n.custom-navbar-header .custom-navbar-header-nav li.active a {\n  opacity: 1;\n  color: #ffffff;\n  font-weight: 500;\n}\n.custom-navbar-header .custom-navbar-header-nav li.active a:before {\n  width: calc(100% - 16px);\n  color: #ffffff;\n  font-weight: 500;\n}\n.custom-navbar-header .custom-navbar-header-cta {\n  margin-left: 0 !important;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n@media (min-width: 768px) {\n  .custom-navbar-header .custom-navbar-header-cta {\n    margin-left: 40px !important;\n  }\n}\n.custom-navbar-header .custom-navbar-header-cta li {\n  margin-left: 0px;\n  margin-right: 0px;\n}\n.custom-navbar-header .custom-navbar-header-cta li:first-child {\n  margin-right: 20px;\n}\n\n.button-navbar {\n  background-color: #4733C9;\n  color: white;\n  font-family: \"Manrope\", sans-serif;\n  border-radius: 5px;\n}\n\n/* ----------------------------- nav bar style start -------------------------------------- */\n\n.navlink-btn .active {\n  background-color: transparent;\n  border: 1px solid #4733C9;\n  color: #4733C9;\n  box-shadow: 0 1px 2px 0 #28af4c3b, 0 1.5px 5px 0 #28af4c3f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
